const AgentIcon = ({ className }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="36" height="36" rx="18" fill="#FEF9C3" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9.04175C15.5838 9.04175 13.625 11.0005 13.625 13.4167C13.625 15.833 15.5838 17.7917 18 17.7917C20.4162 17.7917 22.375 15.833 22.375 13.4167C22.375 11.0005 20.4162 9.04175 18 9.04175ZM14.875 13.4167C14.875 11.6909 16.2741 10.2917 18 10.2917C19.7259 10.2917 21.125 11.6909 21.125 13.4167C21.125 15.1426 19.7259 16.5417 18 16.5417C16.2741 16.5417 14.875 15.1426 14.875 13.4167Z"
        fill="#CD900F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.1907 20.5661C23.0552 20.4896 22.9355 20.4221 22.8386 20.3644C19.8769 18.6009 16.1234 18.6009 13.1617 20.3644C13.0648 20.4221 12.945 20.4897 12.8095 20.5661C12.2155 20.9013 11.3176 21.4078 10.7024 22.0099C10.3177 22.3865 9.95215 22.8828 9.88569 23.4907C9.81502 24.1373 10.0971 24.744 10.6629 25.2831C11.6391 26.2131 12.8106 26.9584 14.3259 26.9584H21.6744C23.1897 26.9584 24.3612 26.2131 25.3374 25.2831C25.9032 24.744 26.1853 24.1373 26.1146 23.4907C26.0481 22.8828 25.6826 22.3865 25.2979 22.0099C24.6827 21.4078 23.7847 20.9012 23.1907 20.5661ZM13.8012 21.4384C16.3689 19.9095 19.6314 19.9095 22.1991 21.4384C22.339 21.5217 22.4923 21.6087 22.6529 21.6998C23.2467 22.0367 23.9401 22.4301 24.4235 22.9032C24.7236 23.197 24.8515 23.4393 24.872 23.6265C24.8883 23.7752 24.8507 24.0203 24.4751 24.378C23.6119 25.2004 22.7348 25.7084 21.6744 25.7084H14.3259C13.2655 25.7084 12.3884 25.2004 11.5251 24.378C11.1496 24.0203 11.112 23.7752 11.1283 23.6265C11.1488 23.4393 11.2767 23.197 11.5768 22.9032C12.0602 22.4301 12.7535 22.0367 13.3474 21.6998C13.5079 21.6087 13.6613 21.5217 13.8012 21.4384Z"
        fill="#CD900F"
      />
    </svg>
  );
};

export default AgentIcon;
